import { render, staticRenderFns } from "./KeyFive.vue?vue&type=template&id=42e19b87&scoped=true&"
import script from "./KeyFive.vue?vue&type=script&lang=js&"
export * from "./KeyFive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e19b87",
  null
  
)

export default component.exports